import { takeLatest, put, call } from 'redux-saga/effects';
import { isAxiosError } from 'axios';
import { notifyError, notifySuccess } from '../actions/action-notifications';
import {
  fetchShippingHolidaysRequest,
  fetchShippingHolidaysSuccess,
  fetchDaysShippingRequest,
  fetchDaysShippingSuccess,
} from '../actions/action-shipping';
import {
  FETCH_SHIPPING_HOLIDAYS_REQUEST,
  FETCH_DAYS_SHIPPING_REQUEST,
  ADD_SHIPPING_HOLIDAYS_REQUEST,
  ADD_WEEKDAYS_REQUEST,
} from '../constants';

function* workerFetchShippingHolidays({ payload }) {
  if (isAxiosError(payload)) {
    yield put(notifyError(payload.response?.data?.message));
  }

  yield put(fetchShippingHolidaysSuccess(payload));
}

function* workerFetchDaysShipping({ payload }) {
  if (isAxiosError(payload)) {
    yield put(notifyError(payload.response?.data?.message));
  }

  yield put(fetchDaysShippingSuccess(payload));
}

function* workerAddShippingHolidays({ payload, customerId }) {
  const response = yield call(() => payload);
  if (isAxiosError(response)) {
    yield put(notifyError(response.data?.message));
  }
  yield put(notifySuccess(response.data?.message));
  yield put(fetchShippingHolidaysRequest(customerId));
}

function* workerAddDaysShipping({ payload, customerId }) {
  const response = yield call(() => payload);
  if (isAxiosError(response)) {
    yield put(notifyError(response.data?.message));
  }
  yield put(notifySuccess('zipcode(s) on weekday successfully added'));
  yield put(fetchDaysShippingRequest(customerId));
}

export function* watcherShippingsSaga() {
  yield takeLatest([FETCH_SHIPPING_HOLIDAYS_REQUEST], workerFetchShippingHolidays);
  yield takeLatest([ADD_SHIPPING_HOLIDAYS_REQUEST], workerAddShippingHolidays);
  yield takeLatest([FETCH_DAYS_SHIPPING_REQUEST], workerFetchDaysShipping);
  yield takeLatest([ADD_WEEKDAYS_REQUEST], workerAddDaysShipping);
}
